module.exports = __webpack_public_path__ + "static/media/Follower_Button-11.3ce169f4.png";